
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiBadgeDialog extends Serenity.EntityDialog<ProdottiBadgeRow, any> {
        protected getFormKey() { return ProdottiBadgeForm.formKey; }
        protected getIdProperty() { return ProdottiBadgeRow.idProperty; }
        protected getLocalTextPrefix() { return ProdottiBadgeRow.localTextPrefix; }
        protected getNameProperty() { return ProdottiBadgeRow.nameProperty; }
        protected getService() { return ProdottiBadgeService.baseUrl; }
        protected getDeletePermission() { return ProdottiBadgeRow.deletePermission; }
        protected getInsertPermission() { return ProdottiBadgeRow.insertPermission; }
        protected getUpdatePermission() { return ProdottiBadgeRow.updatePermission; }

        protected form = new ProdottiBadgeForm(this.idPrefix);

    }
}